import { User } from "../domain/user";
import { getAllUsersService } from "../infrastructure/services/getAllUsersService";
import { tokenValidation } from "@/business/auth/application/tokenValidation";

export const getAllUsers = {
  async execute(): Promise<User[]> {
    return await getAllUsersService.execute(await tokenValidation.execute());
  },
};
